import isValidProp from '@emotion/is-prop-valid';
export const shouldForwardProp = (allowedProps = []) => prop => {
  if (allowedProps.includes(prop)) {
    return true;
  }
  return isValidProp(String(prop));
};
export const shouldNotForwardProp = (forbiddenProps = []) => prop => !forbiddenProps.includes(prop);
//# sourceMappingURL=shouldForwardProp.js.map